import { render } from "./CardView.vue?vue&type=template&id=1550683e&ts=true"
import script from "./CardView.vue?vue&type=script&lang=ts"
export * from "./CardView.vue?vue&type=script&lang=ts"

import "./CardView.vue?vue&type=style&index=0&id=1550683e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__